import Cookies from "js-cookie"
import { safeParse, getCurrentAppFromPath } from "app/vendor/util"

const TOKEN_BUNDLE = "pg_token_bundle"
const TOKEN = "pg_token"
const REFRESH = "refresh_token_flag"
const CURRENT_APP = "pg_current_app"

export function setTokenBundle(loginBundle) {
  const parsedBundle = JSON.parse(loginBundle)
  if (parsedBundle.keepLogin) {
    Cookies.set(TOKEN_BUNDLE, loginBundle, { expires: 1})
  } else {
    Cookies.set(TOKEN_BUNDLE, loginBundle)
  }
  window.localStorage.setItem(TOKEN, parsedBundle.token)
}

export function clearToken() {
  clearRefreshFlag()
  window.localStorage.removeItem('jwt')
  Cookies.remove(TOKEN_BUNDLE)
}

export function getTokenBundle () {
  return Cookies.get(TOKEN_BUNDLE)
}

export function getToken () {
  return safeParse(getTokenBundle()).token
}

export function getUserId () {
  return safeParse(getTokenBundle()).userId
}

export function setCurrentApp (app) {
  return window.sessionStorage.setItem(CURRENT_APP, app)
}

export function getCurrentApp () {
  return window.sessionStorage.getItem(CURRENT_APP) || getCurrentAppFromPath()
}

export function setFirstRefreshFlag () {
  return window.sessionStorage.setItem(REFRESH, "ok")
}

export function getFirstRefreshFlag () {
  return window.sessionStorage.getItem(REFRESH)
}

export function clearRefreshFlag() {
  return window.sessionStorage.removeItem(REFRESH)
}



// WEBPACK FOOTER //
// ./src/app/api/localTools.js